import { Alert } from "@circleco/compass/components/Alert";
import { Button } from "@circleco/compass/components/Button";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { useCheckoutSession } from "@/react/components/Paywalls/Checkout/contexts/CheckoutSessionContext";
import { getCommunityRootUrl } from "@/react/components/Paywalls/CheckoutWithSession/helpers/RoutesHelper";

export const UpgradeAcceptanceRecovery = ({
  isActive,
}: {
  isActive: boolean;
}) => {
  const { session } = useCheckoutSession();
  const {
    formState: { errors },
  } = useFormContext();
  if (!isActive || !errors.root?.message) return null;

  return (
    <div
      className="w-full max-w-xl space-y-3"
      data-testid="upgrade-acceptance-recovery"
    >
      <Alert
        variant="warning"
        description={t("paywall_checkout.offer_page.upgrade.status_unresolved")}
      />
      <Button
        variant="secondary"
        fullWidth
        renderLink={<a href={getCommunityRootUrl(session)} />}
      >
        {t("back_to_community")}
      </Button>
    </div>
  );
};
